import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';
import { FiEdit, FiTrash2, FiPlus, FiX } from 'react-icons/fi';

const defaultForm = {
  name: '', display_name: '', description: '',
  monthly_price: '', quarterly_price: '', yearly_price: '',
  max_staff: 1, max_bookings_per_month: 50, max_services: 5,
  has_gallery: false, has_reviews: false, has_whatsapp_booking: true,
  advance_booking_days: 7, is_active: true, sort_order: 0
};

export default function AdminPlans() {
  const [plans, setPlans] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(defaultForm);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => axios.get('/api/admin/plans').then(r => setPlans(r.data));
  useEffect(() => { load(); }, []);

  const openAdd = () => { setForm(defaultForm); setEditId(null); setModal(true); };
  const openEdit = (plan) => {
    setForm({...plan, has_gallery: !!plan.has_gallery, has_reviews: !!plan.has_reviews, has_whatsapp_booking: !!plan.has_whatsapp_booking, is_active: !!plan.is_active});
    setEditId(plan.id); setModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editId) { await axios.put(`/api/admin/plans/${editId}`, form); toast.success('Plan update ho gaya!'); }
      else { await axios.post('/api/admin/plans', form); toast.success('Plan bana diya!'); }
      setModal(false); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Error'); }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Yeh plan delete karna chahte hain?')) return;
    try { await axios.delete(`/api/admin/plans/${id}`); toast.success('Deleted!'); load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Error'); }
  };

  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="flex-between page-header">
          <div><h1>Subscription Plans</h1><p>Packages aur prices manage karein</p></div>
          <button className="btn btn-primary" onClick={openAdd}><FiPlus /> Naya Plan</button>
        </div>

        <div className="grid-3">
          {plans.map(plan => (
            <div key={plan.id} className="card" style={{ borderTop: `4px solid ${plan.name === 'basic' ? '#74b9ff' : plan.name === 'pro' ? '#a29bfe' : '#fd79a8'}` }}>
              <div className="flex-between mb-3">
                <h3>{plan.display_name}</h3>
                <span className={`badge ${plan.is_active ? 'badge-success' : 'badge-danger'}`}>{plan.is_active ? 'Active' : 'Inactive'}</span>
              </div>
              <p style={{ color: 'var(--text-light)', fontSize: '13px', marginBottom: '16px' }}>{plan.description}</p>
              
              <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '12px', marginBottom: '16px' }}>
                <div className="flex-between" style={{ marginBottom: '6px' }}>
                  <span style={{ fontSize: '13px' }}>Monthly</span>
                  <strong>PKR {Number(plan.monthly_price).toLocaleString()}</strong>
                </div>
                <div className="flex-between" style={{ marginBottom: '6px' }}>
                  <span style={{ fontSize: '13px' }}>Quarterly</span>
                  <strong>PKR {Number(plan.quarterly_price).toLocaleString()}</strong>
                </div>
                <div className="flex-between">
                  <span style={{ fontSize: '13px' }}>Yearly</span>
                  <strong>PKR {Number(plan.yearly_price).toLocaleString()}</strong>
                </div>
              </div>

              <div style={{ fontSize: '12px', color: 'var(--text-light)', marginBottom: '16px' }}>
                <div>👤 Staff: {plan.max_staff === -1 ? 'Unlimited' : plan.max_staff}</div>
                <div>📅 Bookings/month: {plan.max_bookings_per_month === -1 ? 'Unlimited' : plan.max_bookings_per_month}</div>
                <div>✂️ Services: {plan.max_services === -1 ? 'Unlimited' : plan.max_services}</div>
                <div>📷 Gallery: {plan.has_gallery ? '✅' : '❌'} | ⭐ Reviews: {plan.has_reviews ? '✅' : '❌'}</div>
                <div>📅 Advance booking: {plan.advance_booking_days} days</div>
              </div>

              <div className="flex gap-2">
                <button className="btn btn-outline btn-sm" onClick={() => openEdit(plan)}><FiEdit /> Edit</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(plan.id)}><FiTrash2 /></button>
              </div>
            </div>
          ))}
        </div>

        {modal && (
          <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
            <div className="modal" style={{ maxWidth: '600px' }}>
              <div className="modal-header">
                <h3>{editId ? 'Plan Edit Karein' : 'Naya Plan Banayein'}</h3>
                <button className="modal-close" onClick={() => setModal(false)}><FiX /></button>
              </div>
              <form onSubmit={handleSave}>
                <div className="grid-2">
                  <div className="form-group">
                    <label className="form-label">Plan Key (e.g. basic)</label>
                    <input className="form-control" value={form.name} onChange={e => set('name', e.target.value)} required disabled={!!editId} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Display Name</label>
                    <input className="form-control" value={form.display_name} onChange={e => set('display_name', e.target.value)} required />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Description</label>
                  <textarea className="form-control" value={form.description} onChange={e => set('description', e.target.value)} rows={2} />
                </div>
                <div className="grid-3">
                  <div className="form-group">
                    <label className="form-label">Monthly Price (PKR)</label>
                    <input type="number" className="form-control" value={form.monthly_price} onChange={e => set('monthly_price', e.target.value)} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Quarterly Price</label>
                    <input type="number" className="form-control" value={form.quarterly_price} onChange={e => set('quarterly_price', e.target.value)} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Yearly Price</label>
                    <input type="number" className="form-control" value={form.yearly_price} onChange={e => set('yearly_price', e.target.value)} required />
                  </div>
                </div>
                <div className="grid-3">
                  <div className="form-group">
                    <label className="form-label">Max Staff (-1=unlimited)</label>
                    <input type="number" className="form-control" value={form.max_staff} onChange={e => set('max_staff', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Max Bookings/month</label>
                    <input type="number" className="form-control" value={form.max_bookings_per_month} onChange={e => set('max_bookings_per_month', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Max Services</label>
                    <input type="number" className="form-control" value={form.max_services} onChange={e => set('max_services', e.target.value)} />
                  </div>
                </div>
                <div className="grid-2">
                  <div className="form-group">
                    <label className="form-label">Advance Booking (days)</label>
                    <input type="number" className="form-control" value={form.advance_booking_days} onChange={e => set('advance_booking_days', e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Sort Order</label>
                    <input type="number" className="form-control" value={form.sort_order} onChange={e => set('sort_order', e.target.value)} />
                  </div>
                </div>
                <div className="flex gap-3 mb-4" style={{ flexWrap: 'wrap' }}>
                  {[['has_gallery', '📷 Gallery'], ['has_reviews', '⭐ Reviews'], ['has_whatsapp_booking', '📲 WhatsApp Booking'], ['is_active', '✅ Active']].map(([k, label]) => (
                    <label key={k} style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '14px' }}>
                      <input type="checkbox" checked={form[k]} onChange={e => set(k, e.target.checked)} />
                      {label}
                    </label>
                  ))}
                </div>
                <button className="btn btn-primary btn-full" type="submit" disabled={saving}>
                  {saving ? 'Saving...' : editId ? '💾 Update Plan' : '✅ Plan Banao'}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
